/* eslint-disable */
import CohortPivot from "./cohortPivot.vue";

export default {
  name: "enrollmentsummarybycohort",
  components: {
    CohortPivot,
  },
  methods: {
    onclosed() {
      this.$router.push("./reportdashboard")
    }
  }
};